import { render } from "./ConfirmDialog.vue?vue&type=template&id=0432420d&ts=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=0432420d&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__